import { usePostHttp } from "../../http.hook";
import type { IFavoriteSocial } from "./get-all-favorites.admin.http";

interface IBody {
  name: string;
  description: string;
  socials: [];
}

interface IResponse {
  favouriteSocial: IFavoriteSocial;
}

export function useAddNewFavoriteCollectionAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/favourite-socials",
  });
}
